// ─── Coach-set nutrition targets (member side) ───
// `my_nutrition_targets` → { targets | null, coach }. When a coach has set targets they
// replace the member's own daily goals on screen; the member's stored `goals` are never
// written, so they come back as soon as the targets are cleared. No imports so
// tests/nutrition-targets.test.mjs can load this file directly in Node.

export const NUTRITION_TARGETS_CACHE_KEY = "ft-org-nutrition-targets";

// API field → key in the app's `goals` object
const GOAL_KEY = { calories: "cal", protein: "protein", carbs: "carbs", fat: "fat", fiber: "fiber" };

const num = (v) => (typeof v === "number" && Number.isFinite(v) && v >= 0 ? v : null);

// True when at least one target is set.
export const hasTargets = (t) => !!(t && Object.keys(GOAL_KEY).some(k => num(t[k]) != null));

// The day's goals: the member's own goals with every coach-set target on top.
// Returns { goals, coachKeys } — coachKeys lists the goal keys that came from the coach.
export function effectiveGoals(own, targets) {
  const base = own && typeof own === "object" ? own : {};
  if (!hasTargets(targets)) return { goals: base, coachKeys: [] };
  const goals = { ...base };
  const coachKeys = [];
  for (const [field, key] of Object.entries(GOAL_KEY)) {
    const v = num(targets[field]);
    if (v == null) continue;
    goals[key] = v;
    coachKeys.push(key);
  }
  return { goals, coachKeys };
}

// "2,200 kcal · 180 g protein · 250 g carbs"
export function targetsLine(t) {
  if (!t) return "";
  const parts = [];
  if (num(t.calories) != null) parts.push(`${t.calories.toLocaleString("en-US")} kcal`);
  for (const k of ["protein", "carbs", "fat", "fiber"]) if (num(t[k]) != null) parts.push(`${t[k]} g ${k}`);
  return parts.join(" · ");
}

// "Set by Sam C." — the coach's name, else a neutral fallback (coach account deleted).
export function targetsSource(coach) {
  const name = coach && (coach.name || coach.first_name || (coach.email || "").split("@")[0]);
  return name ? `Set by ${name}` : "Set by your coach";
}
